import React from "react";
import { BrowserRouter } from "react-router-dom";

import { AuthLayout } from "@/layouts/AuthLayout";

function App(): React.ReactElement {
  return (
    <BrowserRouter>
      <AuthLayout />
    </BrowserRouter>
  );
}

export default App;
